<template>
  <div>
    
  </div>
</template>

<script>
// import { Row, Col, Icon, Cell, CellGroup } from 'vant';
import { toLogin, setToken, getToken } from '@/utils/auth'

export default {
  components: {
    // [Row.name]: Row,
    // [Col.name]: Col,
    // [Icon.name]: Icon,
    // [Cell.name]: Cell,
    // [CellGroup.name]: CellGroup
  },
  activated(){
    this.dispatch()
  },
  created(){
    this.dispatch()
  },
  methods: {
    dispatch(){
      let page = this.$route.query.page;
      let token = this.$route.query.token;
      // console.log('query-page:' + page)
      // console.log('query-token:' + token)
      if(!page) {
        page = "apply"
      }
      if(!token){
        token = getToken()
      }
      console.log('token:' + token)
      if(token){
        setToken(token)
        this.$router.replace(page)
      } else {
        toLogin(page)
      }
    }
  }
};
</script>

